<div *ngIf='componentReady' class='Paginator'>
  <div class='flex-grow-0 Paginator__page-info me-3'>
    Page {{ currentPage }} of {{ length }}
  </div>
  <div class='flex-grow-1 Paginator__page-buttons'>
    <span
      (click)="goToPage('first')"
      *ngIf='showFirstLastButtons && currentPage !== 1'
      class='page-button'
    >first</span
    >
    <span
      (click)="goToPage('prev')"
      *ngIf='showPrevNextButtons && currentPage !== 1'
      class='page-button'
    >previous</span
    >
    <span (click)="goToPage('prev')" *ngIf='currentPage - 1 >= 1'>{{
        currentPage - 1
      }}</span>
    <span class='activePage'>{{ currentPage }}</span>
    <span (click)="goToPage('next')" *ngIf='currentPage + 1 <= length'>{{
        currentPage + 1
      }}</span>
    <span
      (click)="goToPage('next')"
      *ngIf='showPrevNextButtons && currentPage !== length'
      class='page-button'
    >next</span
    >
    <span
      (click)="goToPage('last')"
      *ngIf='showFirstLastButtons && currentPage !== length'
      class='page-button'
    >last</span
    >
  </div>
  <div class='flex-grow-1 Paginator__items-count d-flex align-items-center'>
    <span class='me-3'>Items {{ getPageSize() }} of {{ totalCount }}</span>
    <app-select
      (selection)='onPageSizeSelection($event)'
      *ngIf='showItemsPerPage'
      [defaultValue]='pageSize'
      [items]='buildPageSizeSelector()'
      [label]="'Items per page'"></app-select>
  </div>
</div>
